import type { DealRefreshStateTree } from './types';

export const isDealRefreshModalVisible = (state: DealRefreshStateTree): boolean => state.dealRefreshModal?.isVisible ?? false;
